const InfoIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 14.75C3.11719 14.75 0 11.6328 0 7.75C0 3.89453 3.11719 0.75 7 0.75C10.8555 0.75 14 3.89453 14 7.75C14 11.6328 10.8555 14.75 7 14.75ZM5.90625 9.9375C5.52344 9.9375 5.25 10.2383 5.25 10.5938C5.25 10.9766 5.52344 11.25 5.90625 11.25H8.09375C8.44922 11.25 8.75 10.9766 8.75 10.5938C8.75 10.2383 8.44922 9.9375 8.09375 9.9375H7.875V7.53125C7.875 7.17578 7.57422 6.875 7.21875 6.875H5.90625C5.52344 6.875 5.25 7.17578 5.25 7.53125C5.25 7.91406 5.52344 8.1875 5.90625 8.1875H6.5625V9.9375H5.90625ZM7 6C7.46484 6 7.875 5.61719 7.875 5.125C7.875 4.66016 7.46484 4.25 7 4.25C6.50781 4.25 6.125 4.66016 6.125 5.125C6.125 5.61719 6.50781 6 7 6Z"
      fill="#353535"
    ></path>
  </svg>
);
export default InfoIcon;
